/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_NextInputs */

const en_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`next`)
};

const ar_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التالي`)
};

const bn_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরবর্তী`)
};

const de_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`als nächstes`)
};

const es_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`siguiente`)
};

const fr_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suivant`)
};

const pt_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`próximo`)
};

const zh_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个`)
};

const tr_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sonraki`)
};

const ru_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`следующий`)
};

const pl_cta_next = /** @type {(inputs: Cta_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`następny`)
};

/**
* | output |
* | --- |
* | "next" |
*
* @param {Cta_NextInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_next = /** @type {((inputs?: Cta_NextInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_NextInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_next(inputs)
	if (locale === "bn") return bn_cta_next(inputs)
	if (locale === "de") return de_cta_next(inputs)
	if (locale === "es") return es_cta_next(inputs)
	if (locale === "fr") return fr_cta_next(inputs)
	if (locale === "pt") return pt_cta_next(inputs)
	if (locale === "zh") return zh_cta_next(inputs)
	if (locale === "tr") return tr_cta_next(inputs)
	if (locale === "ru") return ru_cta_next(inputs)
	if (locale === "pl") return pl_cta_next(inputs)
	return en_cta_next(inputs)
});